import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=e0b15192&scoped=true&"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=e0b15192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b15192",
  null
  
)

export default component.exports